export default (money: string | number): string => {
  return parseFloat((money || 0).toString()).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });
};
